import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, defaultIfEmpty, timeout } from 'rxjs/operators';
import { of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as ActionsList from './actions';
import { GreenIdService } from '../../services/greenid.service';

@Injectable()
export class GreenIdEffects {
  constructor(
    private actions$: Actions,
    private service: GreenIdService,
    private toastr: ToastrService
  ) {}

  getVerificationToken$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActionsList.RequestVerificationCodeAction),
      switchMap((action: any) =>
        this.service.getVerificationToken(action.account)
      ),
      map((data: any) => {
        return ActionsList.ResponseVerificationCodeAction({ data: data.data });
      })
    )
  );

  accountVerified$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActionsList.RequestVerifiedAction),
      switchMap((action: any) =>
        this.service.validated(action.account, action.verificationId)
      ),
      map((data: any) => {
        return ActionsList.ResponseVerifiedAction({ data: data.data });
      })
    )
  );

  recordConsent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActionsList.RecordConsentAction),
      switchMap((action: any) =>
        this.service.recordConsent(action.account, action.verificationId).pipe(
          timeout(20000),
          defaultIfEmpty(null as any),
          map((result: any) => {
            const failed =
              result instanceof HttpErrorResponse ||
              result == null ||
              result.name === 'HttpErrorResponse' ||
              result.ok === false ||
              (typeof result.status === 'number' && result.status >= 400);

            if (failed) {
              this.toastr.error(
                'There was a problem recording your consent. Please try again.'
              );
              return ActionsList.ConsentFailedAction();
            }
            return ActionsList.ResponseConsentAction();
          }),
          catchError(() => {
            this.toastr.error(
              'There was a problem recording your consent. Please try again.'
            );
            return of(ActionsList.ConsentFailedAction());
          })
        )
      )
    )
  );
}
